import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CalendarPersonIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 25",
                    children: _jsx("path", {
                        d: "M8 1.155a1 1 0 011 1v.892h6v-.892a1 1 0 112 0v.892h2a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3v-14a3 3 0 013-3h2v-.892a1 1 0 011-1zm7 3.892v1.108a1 1 0 102 0V5.047h2a1 1 0 011 1v14a1 1 0 01-1 1 .999.999 0 00-.042-.287l-.558-1.862a4 4 0 00-3.832-2.85H9.432a4 4 0 00-3.831 2.85l-.559 1.862a1 1 0 00-.042.287 1 1 0 01-1-1v-14a1 1 0 011-1h2v1.108a1 1 0 002 0V5.047h6zm1.484 14.426l.472 1.574H7.044l.473-1.574a2 2 0 011.915-1.426h5.136a2 2 0 011.916 1.426zM14 11.047a2 2 0 11-4 0 2 2 0 014 0zm2 0a4 4 0 11-8 0 4 4 0 018 0z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
CalendarPersonIcon.isCarinaIcon = true;
export default CalendarPersonIcon;
